function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var REM_SIZE = 16;
export function buildTypography(args) {
    var arg;
    if ('theme' in args) {
        arg = args;
    } else {
        arg = {
            theme: args
        };
    }
    var theme = arg.theme, breakpoints = arg.breakpoints, flags = arg.flags;
    var font = theme.font;
    var s = (breakpoints !== null && breakpoints !== void 0 ? breakpoints : {}).s;
    var ref = flags !== null && flags !== void 0 ? flags : {}, typographyUpdates = ref.typographyUpdates, responsiveHeadings = ref.responsiveHeadings;
    return {
        html: {
            fontSize: REM_SIZE
        },
        body: {
            fontSize: font.base.size.s,
            lineHeight: font.lineHeight.base,
            fontWeight: font.base.weight.regular,
            fontFamily: font.base.family,
            color: font.color.base,
            WebkitFontSmoothing: 'antialiased'
        },
        base: {
            h1: _objectSpread({
                fontSize: font.base.size.h1,
                lineHeight: font.lineHeight.heading,
                fontWeight: typographyUpdates ? font.base.weight.medium : font.base.weight.regular,
                fontFamily: font.base.family,
                color: font.color.base
            }, responsiveHeadings && _defineProperty({}, "@media only screen and (max-width: ".concat(s, "px)"), {
                fontSize: font.base.size[8]
            })),
            h2: _objectSpread({
                fontSize: font.base.size.h2,
                lineHeight: font.lineHeight.heading,
                fontWeight: typographyUpdates ? font.base.weight.bold : font.base.weight.regular,
                fontFamily: font.base.family,
                color: font.color.base
            }, responsiveHeadings && _defineProperty({}, "@media only screen and (max-width: ".concat(s, "px)"), {
                fontSize: font.base.size[6]
            })),
            h3: _objectSpread({
                fontSize: font.base.size.h3,
                lineHeight: font.lineHeight.heading,
                fontWeight: typographyUpdates ? font.base.weight.bold : font.base.weight.regular,
                fontFamily: font.base.family,
                color: font.color.base
            }, responsiveHeadings && _defineProperty({}, "@media only screen and (max-width: ".concat(s, "px)"), {
                fontSize: font.base.size[5]
            })),
            h4: _objectSpread({
                fontSize: font.base.size.h4,
                lineHeight: font.lineHeight.heading,
                fontWeight: typographyUpdates ? font.base.weight.bold : font.base.weight.regular,
                fontFamily: font.base.family,
                color: font.color.base
            }, responsiveHeadings && _defineProperty({}, "@media only screen and (max-width: ".concat(s, "px)"), {
                fontSize: font.base.size[4]
            })),
            h5: {
                fontSize: font.base.size.h5,
                lineHeight: font.lineHeight.heading,
                fontWeight: typographyUpdates ? font.base.weight.bold : font.base.weight.regular,
                fontFamily: font.base.family,
                color: font.color.soft,
                textTransform: 'uppercase'
            },
            h6: {
                fontSize: font.base.size.h6,
                lineHeight: font.lineHeight.heading,
                fontWeight: typographyUpdates ? font.base.weight.bold : font.base.weight.regular,
                fontFamily: font.base.family,
                color: font.color.soft,
                textTransform: 'uppercase'
            },
            ul: {
                fontSize: font.base.size.s,
                lineHeight: font.lineHeight.base,
                fontWeight: font.base.weight.regular,
                fontFamily: font.base.family,
                color: font.color.base,
                paddingInlineStart: '1rem'
            },
            ol: {
                fontSize: font.base.size.s,
                lineHeight: font.lineHeight.base,
                fontWeight: font.base.weight.regular,
                fontFamily: font.base.family,
                color: font.color.base,
                paddingInlineStart: '1rem'
            },
            p: {
                fontSize: font.base.size.s,
                lineHeight: font.lineHeight.base,
                fontWeight: font.base.weight.regular,
                fontFamily: font.base.family,
                color: font.color.base
            }
        },
        prose: {
            ul: {
                fontSize: font.prose.size.s,
                lineHeight: font.lineHeight.prose,
                fontWeight: font.prose.weight.regular,
                fontFamily: font.prose.family,
                color: font.color.base,
                paddingInlineStart: '1rem'
            },
            ol: {
                fontSize: font.prose.size.s,
                lineHeight: font.lineHeight.prose,
                fontWeight: font.prose.weight.regular,
                fontFamily: font.prose.family,
                color: font.color.base,
                paddingInlineStart: '1rem'
            },
            span: {
                fontSize: font.prose.size.s,
                lineHeight: font.lineHeight.prose,
                fontWeight: font.prose.weight.regular,
                fontFamily: font.prose.family,
                color: font.color.base
            },
            p: {
                fontSize: font.prose.size.s,
                lineHeight: font.lineHeight.prose,
                fontWeight: font.prose.weight.regular,
                fontFamily: font.prose.family,
                color: font.color.base
            }
        },
        mono: {
            pre: {
                fontSize: font.mono.size.s,
                lineHeight: font.lineHeight.base,
                fontWeight: font.mono.weight.regular,
                fontFamily: font.mono.family,
                color: font.color.base
            },
            code: {
                fontSize: font.mono.size.s,
                lineHeight: font.lineHeight.base,
                fontWeight: font.mono.weight.regular,
                fontFamily: font.mono.family,
                color: font.color.base
            }
        }
    };
}
export default buildTypography;
